<section class="section-pd">
    <div class="trinka_container">
        <div class="secure-wrapper">
            <div class="row align-items-center match-box">
                <div class="col-md-6 col-lg-6 dflex">
                    <div class="trinka-title mb-0">
                        <h2>安全、可靠、值得信赖</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p class="mb-2">Trinka 始终将您的数据安全和隐私放在首位。您的所有数据都经过严格加密并安全存储，确保任何人都无法访问您的信息。您可以随时在后台删除您的数据。</p>
                        <p class="mb-30">高级用户的数据将在每90天自动从所有系统中删除。为进一步加强安全性并满足合规要求，我们提供多种选项，包括敏感数据计划，以更有效地保护您的私人数据。</p>
                        <!-- <div class="btn-group">
                            <a href="/data-security" class="filled-btn">Know More</a>
                        </div> -->
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 dflex ">
                    <div class="text-center">
                        <img src="assets/images/homepage/data-security.svg" class="img-fluid" loading="lazy" decoding="async" alt="data-security">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>